export default "__VITE_ASSET__1232013e__"